/**
 * A Home type's glyph on a faint tile of its hue: the Dashboard's tiles,
 * widget headers and runway lanes. The hue marks the type only; status keeps
 * the semantic tones.
 */
import type { FC } from "react";

import { KINDS, type Kind } from "@/components/ui/kind-icon";
import { cn } from "@/lib/utils";

const TINT: Record<Kind, string> = {
  deadline: "bg-kind-deadline/12 text-kind-deadline",
  expiration: "bg-kind-expiration/12 text-kind-expiration",
  agent: "bg-kind-agent/12 text-kind-agent",
  intake: "bg-kind-intake/12 text-kind-intake",
  calendar: "bg-kind-calendar/12 text-kind-calendar"
};

type Props = {
  kind: Kind;
  /** `sm` 18px (runway lanes), `md` 20px (tiles, widgets). */
  size?: "sm" | "md";
  className?: string;
};

export const KindTile: FC<Props> = ({ kind, size = "md", className }) => {
  const Icon = KINDS[kind].icon;
  return (
    <span
      aria-hidden
      data-kind={kind}
      className={cn(
        "inline-flex shrink-0 items-center justify-center",
        size === "sm" ? "size-4.5 rounded-sm" : "size-5 rounded-md",
        TINT[kind],
        className
      )}
    >
      <Icon
        className={size === "sm" ? "size-3" : "size-3.25"}
        strokeWidth={2}
      />
    </span>
  );
};
